import styled from 'styled-components';

export const FooterWrapper = styled.footer`
    border-top: 1px solid #293247;
    
    padding: 15px;
    background: ${({theme}) => theme.body};
    position: absolute;
    width: calc(100% - 30px);
`